/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ServiceIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 72 63"
    onClick={props.onClick}
  >
    <g fill="none">
      <g strokeWidth="2" transform="translate(1.5 1.5)">
        <path
          strokeLinecap="round"
          d="M69 49.236C69 51.867 66.987 54 64.5 54h-60C2.016 54 0 51.867 0 49.236V4.764C0 2.133 2.016 0 4.5 0h60C66.987 0 69 2.133 69 4.764v44.472zM13.5 60h42M34.5 54v6"
        />
        <circle cx="34.5" cy="48" r="1.5" />
        <path d="M0 42h69" />
      </g>
    </g>
  </svg>
);

export default ServiceIcon;
